
export default {
    show: (data) => window.axios.post('get_faq_all',data)
}